import { h, Component, Element, Prop } from '@stencil/core';
import type { ComponentInterface } from '@stencil/core';

@Component({
	tag: 'app-icon',
	styleUrl: 'icon.scss'
})
export class Icon implements ComponentInterface {
	@Element() root: HTMLElement;

	@Prop() sheet = iconSheet ?? '/icon/sheets/icons.svg';
	@Prop({ reflect: true }) icon: string;
	@Prop() cssClass?: string;

	componentWillLoad() {
		// this should be done with ElementInternals.role when that's supported
		if (!this.root.hasAttribute('role'))
			this.root.setAttribute('role', 'presentation');
	}

	render() {
		return (
			<svg aria-hidden='true' class={this.cssClass}>
				<use href={`${assetPath}${this.sheet}#${this.icon}`} />
			</svg>
		);
	}
}
